import AICampusFooter from "@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue";
import navbar from "@/components/probaworkflows_base_components/Navbar/NavBar.vue";
import NavigationBackButton from '@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue';
import {
  PUBLIC_JOB_CATALOG_URL,
  PUBLIC_JOB_ADVERT_URL,
  get_headers,
} from "@/utils/constants/constants";
import axios from "axios";
import alert_mixin from "@/utils/mixins/alert_mixin";


function normalizeSectionTitleValue(title) {
  return String(title || '').trim();
}

function getSectionBadgeMatch(title) {
  return normalizeSectionTitleValue(title).match(/^([A-Z])\.\s*/i);
}

export default {
  name: "ViewJobsAdvertised",
  mixins: [alert_mixin],
  components: {
    AICampusFooter,
    NavigationBackButton,
    navbar
  },
  data: () => ({
    hostname: window.location.hostname,
    headers: get_headers(),
    projects: [],
    sub_programs: [],
    jobs: [],
    loading_jobs: false,
    has_loaded_jobs_once: false,
    current_page: 1,
    items_per_page: 6,
    filters: {
      programmeId: '',
      status: '',
      search: '',
      sortBy: 'recent',
    },
    status_options: [
      { value: '', label: 'All Statuses' },
      { value: 'Open', label: 'Open' },
      { value: 'Closing Soon', label: 'Closing Soon' },
      { value: 'Closed', label: 'Closed' },
    ],
    loading_profile: false,
    job_profile: {
      title: '',
      description: '',
      sections: [],
      advert_details: '',
      advert_sections: [],
      advert_order: [],
      display_blocks: [],
    },
    job: {
        id: null,
      advertId: null,
        projectId: null,
        departmentId: null,
        title: '',
        jobTitle: '',
        departmentName: '',
        status: '',
        recruitingPeriod: '',
      informationSummary: [],
      formSections: [],
      jobSpecSections: [],
      jobPurpose: '',
      rawSpecText: '',
        details: '',
        shareLink: '',
        referenceNumber: '',
        competencies: [],
    },

    showFilters: false,
    windowWidth: window.innerWidth,
    job_age_now: Date.now(),
    job_age_timer: null,
  }),

  computed: {
    programme_options() {
      return (this.sub_programs || []).map((sp) => ({
        label: sp.name,
        value: String(sp.id),
      }));
    },

    filtered_jobs() {
      const search_text = (this.filters.search || '').trim().toLowerCase();

      let filtered = (this.jobs || []).filter((job) => {
        const matches_programme = !this.filters.programmeId || String(job.subProgramId) === String(this.filters.programmeId);
        const matches_status = !this.filters.status || job.status === this.filters.status;
        const matches_search = !search_text
          || (job.jobTitle || '').toLowerCase().includes(search_text)
          || (job.referenceNumber || '').toLowerCase().includes(search_text);

        return matches_programme && matches_status && matches_search;
      });

      if (this.filters.sortBy === 'title') {
        filtered = filtered.sort((left, right) => (left.jobTitle || '').localeCompare(right.jobTitle || ''));
      } else if (this.filters.sortBy === 'closing') {
        filtered = filtered.sort((left, right) => {
          const left_date = left.closingDate ? new Date(left.closingDate).getTime() : Number.MAX_SAFE_INTEGER;
          const right_date = right.closingDate ? new Date(right.closingDate).getTime() : Number.MAX_SAFE_INTEGER;
          return left_date - right_date;
        });
      } else {
        filtered = filtered.sort((left, right) => {
          const left_date = left.publishedDate ? new Date(left.publishedDate).getTime() : 0;
          const right_date = right.publishedDate ? new Date(right.publishedDate).getTime() : 0;
          return right_date - left_date;
        });
      }

      return filtered;
    },

    paginated_jobs() {
      const start = (this.current_page - 1) * this.items_per_page;
      const end = start + this.items_per_page;
      return this.filtered_jobs.slice(start, end);
    },

    total_pages() {
      return Math.ceil(this.filtered_jobs.length / this.items_per_page);
    },
  },

  async created() {
    await this.ensure_jobs_loaded();
    await this.open_shared_advert_from_query();
  },

  mounted() {
    this.job_age_timer = setInterval(() => {
      this.job_age_now = Date.now();
    }, 60000);
  },

  beforeUnmount() {
    if (this.job_age_timer) {
      clearInterval(this.job_age_timer);
      this.job_age_timer = null;
    }
  },

  activated() {
    this.ensure_jobs_loaded();
  },

  methods: {
    read_prop(target, key, fallback = null) {
      if (!target || !Reflect.has(target, key)) {
        return fallback;
      }
      const value = Reflect.get(target, key);
      return value ?? fallback;
    },

    async ensure_jobs_loaded() {
      if (this.loading_jobs) {
        return;
      }

      if (this.has_loaded_jobs_once && this.jobs.length) {
        return;
      }

      await this.fetch_jobs_for_all_projects();
    },

    normalize_api_payload(raw_payload) {
      if (!raw_payload) {
        const empty_payload = {};
        return empty_payload;
      }

      if (typeof raw_payload === 'string') {
        try {
          return JSON.parse(raw_payload);
        } catch (error) {
          const invalid_payload = {};
          return invalid_payload;
        }
      }

      return raw_payload;
    },

    infer_job_status(closing_date) {
      if (!closing_date) {
        return 'Open';
      }

      const now = new Date();
      const closing = new Date(closing_date);
      const ms_remaining = closing.getTime() - now.getTime();
      const days_remaining = ms_remaining / (1000 * 60 * 60 * 24);

      if (days_remaining < 0) {
        return 'Closed';
      }

      if (days_remaining <= 7) {
        return 'Closing Soon';
      }

      return 'Open';
    },

    get_status_badge_class(status) {
      if (status === 'Closed') {
        return 'text-bg-secondary';
      }

      if (status === 'Closing Soon') {
        return 'text-bg-warning';
      }

      return 'text-bg-success';
    },

    clear_filters() {
      this.filters = {
        programmeId: '',
        status: '',
        search: '',
        sortBy: 'recent',
      };
      this.current_page = 1;
    },
    on_filter_change() {
      this.current_page = 1;
    },


    get_spec_lines(spec_text) {
      if (!spec_text) {
        return [];
      }

      // If it's already an object/array, stringify it safely
      let text = '';

      if (typeof spec_text === 'string') {
        text = spec_text;
      } else if (typeof spec_text === 'object') {
        try {
          text = JSON.stringify(spec_text, null, 2);
        } catch (e) {
          text = '';
        }
      } else {
        text = String(spec_text);
      }

      text = text.replace(/\r\n/g, '\n').trim();

      if (!text) {
        return [];
      }

      return text
        .split('\n')
        .map((line) => line.trim())
        .filter((line) => !!line);
    },

    to_section_blocks(lines) {
      const heading_regex = /^([A-J])\.\s*(.+)$/i;
      const sections = [];
      let current_section = null;

      for (const line of lines) {
        const heading_match = line.match(heading_regex);
        if (heading_match) {
          current_section = { code: heading_match[1].toUpperCase(), heading: heading_match[2].trim(), lines: [] };
          sections.push(current_section);
          continue;
        }

        if (!current_section) {
          current_section = { code: '', heading: 'Overview', lines: [] };
          sections.push(current_section);
        }
        current_section.lines.push(line);
      }

      return sections;
    },

    parse_tab_row(line) {
      const tab_index = line.indexOf('\t');
      if (tab_index < 0) {
        return null;
      }
      const label = line.slice(0, tab_index).trim();
      const value = line.slice(tab_index + 1).trim();
      if (!label) {
        return null;
      }
      const tab_row = { label, value: value || '-' };
      return tab_row;
    },

    parse_colon_row(line) {
      const colon_match = line.match(/^([^:]{2,50}):\s*(.+)$/);
      if (!colon_match) {
        return null;
      }
      const colon_row = {
        label: colon_match[1].trim(),
        value: colon_match[2].trim() || '-',
      };
      return colon_row;
    },

    parse_section_content(lines) {
      const parsed = { rows: [], bullets: [], paragraphs: [] };

      for (const line of lines) {
        if (/^[Ã¢â‚¬Â¢-]\s*/.test(line)) {
          parsed.bullets.push(line.replace(/^[Ã¢â‚¬Â¢-]\s*/, '').trim());
          continue;
        }

        const tab_row = this.parse_tab_row(line);
        if (tab_row) {
          parsed.rows.push(tab_row);
          continue;
        }

        const colon_row = this.parse_colon_row(line);
        if (colon_row) {
          parsed.rows.push(colon_row);
          continue;
        }

        parsed.paragraphs.push(line);
      }

      return parsed;
    },

    build_job_spec_sections(spec_text) {
      const section_blocks = this.to_section_blocks(this.get_spec_lines(spec_text));
      return section_blocks.map((section) => {
        const parsed = this.parse_section_content(section.lines || []);
        const section_payload = {
          code: section.code,
          heading: section.heading,
          rows: parsed.rows,
          bullets: parsed.bullets,
          paragraphs: parsed.paragraphs,
        };
        return section_payload;
      });
    },

    extract_job_purpose(spec_text, fallback_text) {
      const sections = this.build_job_spec_sections(spec_text);
      const purpose_section = sections.find((section) => section.code === 'B');
      if (purpose_section) {
        const first_paragraph = purpose_section.paragraphs?.[0] || '';
        if (first_paragraph) {
          return first_paragraph;
        }
      }
      return fallback_text || 'No job purpose has been provided.';
    },

    group_attribute_questions(attribute_questions = []) {
      if (!attribute_questions.length) {
        return [];
      }

      return [{
        section_name: 'General Form Questions',
        questions: attribute_questions,
      }];
    },

    format_period(published_date, closing_date) {
      const from = published_date ? new Date(published_date).toLocaleDateString() : 'Open';
      const to = closing_date ? new Date(closing_date).toLocaleDateString() : 'Open';
      return `${from} to ${to}`;
    },

    format_display_date(date_str) {
      if (!date_str) return '';
      const d = new Date(date_str);
      if (isNaN(d.getTime())) return date_str;
      return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    },

    format_display_datetime(date_str) {
      if (!date_str) return '';
      const date = new Date(date_str);
      if (isNaN(date.getTime())) return date_str;

      const has_time =
        typeof date_str === 'string'
        && (/[T\s]\d{2}:\d{2}/.test(date_str) || /\d{2}:\d{2}/.test(date_str));

      const formatted_date = date.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      });

      if (!has_time) {
        return formatted_date;
      }

      const formatted_time = date.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
      });

      return `${formatted_date} - ${formatted_time}`;
    },

    format_elapsed_from_datetime(datetime_value) {
      if (!datetime_value) return '';

      const created_time = new Date(datetime_value).getTime();
      if (Number.isNaN(created_time)) return '';

      const total_minutes = Math.max(0, Math.floor((this.job_age_now - created_time) / 60000));
      const days = Math.floor(total_minutes / 1440);
      const hours = Math.floor((total_minutes % 1440) / 60);
      const minutes = total_minutes % 60;

      return `${days} ${days === 1 ? 'day' : 'days'} ${hours} ${hours === 1 ? 'hour' : 'hours'} ${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
    },

    normalize_job(job_row, advert_row = null) {
      const job_title = this.read_prop(job_row, 'entity_type_name', 'Untitled Job');
      const form_sections_data = this.read_prop(job_row, 'form_sections', []);
      const attribute_questions = this.read_prop(job_row, 'attribute_questions', []);
      const raw_spec_text = this.read_prop(job_row, 'job_spec_text', this.read_prop(job_row, 'entity_type_description', ''));
      const form_sections = form_sections_data.length ? form_sections_data : this.group_attribute_questions(attribute_questions);
      const advert = advert_row || {};

      const closing_date = this.read_prop(advert, 'closing_date', this.read_prop(job_row, 'closing_date', null));
      const published_date = this.read_prop(advert, 'published_date', this.read_prop(job_row, 'published_date', null));
      const date_created = this.read_prop(advert, 'date_created', this.read_prop(job_row, 'date_created', null));
      const reference_number = this.read_prop(advert, 'reference_number', this.read_prop(job_row, 'reference_number', '-'));
      const advert_title = this.read_prop(advert, 'title', job_title);
      const advert_details = this.read_prop(advert, 'details', this.read_prop(job_row, 'entity_type_description', 'No details were provided for this job profile.'));

      const normalized_job = {
        id: this.read_prop(job_row, 'id', null),
        advertId: this.read_prop(advert, 'id', null),
        projectId: this.read_prop(job_row, 'project_id', null),
        subProgramId: this.read_prop(job_row, 'sub_program_id', null),
        subProgramName: this.read_prop(job_row, 'sub_program_name', null),
        title: advert_title,
        jobTitle: advert_title,
        status: this.infer_job_status(closing_date),
        recruitingPeriod: this.format_period(published_date, closing_date),
        informationSummary: this.read_prop(job_row, 'information_summary', []),
        formSections: form_sections,
        jobSpecSections: this.build_job_spec_sections(raw_spec_text),
        jobPurpose: this.extract_job_purpose(raw_spec_text, this.read_prop(job_row, 'entity_type_description', '')),
        rawSpecText: raw_spec_text,
        details: advert_details,
        shareLink: this.read_prop(job_row, 'share_link', ''),
        referenceNumber: reference_number,
        publicToken: this.read_prop(advert, 'public_token', ''),
        publishedDate: published_date,
        closingDate: closing_date,
        dateCreated: date_created,
        competencies: [],
      };
      return normalized_job;
    },

    go_to_page(page) {
      if (page >= 1 && page <= this.total_pages) {
        this.current_page = page;
      }
    },

    async fetch_jobs_for_all_projects() {
      this.loading_jobs = true;
      try {
        const response = await axios.get(PUBLIC_JOB_CATALOG_URL);
        const parsed_response = this.normalize_api_payload(response.data);
        const payload = parsed_response?.data || {};
        this.projects = payload.departments || [];
        this.sub_programs = payload.sub_programs || [];
        const job_rows = payload.jobs || [];
        this.jobs = job_rows.flatMap((job_row) => {
          const adverts = Array.isArray(job_row?.adverts) && job_row.adverts.length
            ? job_row.adverts
            : [];

          const seen_advert_ids = new Set();
          const unique_open_adverts = adverts.filter((advert) => {
            const advert_id = Number(advert?.id || 0);
            if (!advert_id || seen_advert_ids.has(advert_id)) {
              return false;
            }
            
            // Filter out closed adverts - if closing_date is in the past, don't show it
            const closing_date = advert?.closing_date;
            if (closing_date) {
              const closing = new Date(closing_date);
              const now = new Date();
              if (closing < now) {
                return false; // Advert is closed, skip it
              }
            }
            
            seen_advert_ids.add(advert_id);
            return true;
          });

          return unique_open_adverts.map((advert_row) => this.normalize_job(job_row, advert_row));
        });
        this.current_page = 1;

        const default_share_link = this.read_prop(this.jobs[0], 'shareLink', '');
        if (default_share_link) {
          sessionStorage.setItem('public_default_share_link', default_share_link);
        }

        this.has_loaded_jobs_once = true;
      } catch (error) {
        const message = error.response?.data?.message || error.message || 'Unknown error';
        this.show_error('Error loading jobs: ' + message);
      } finally {
        this.loading_jobs = false;
      }
    },

    async open_job_details(selected_job) {
      this.job = {
        ...selected_job,
        competencies: [],
      };

      const selected_share_link = this.read_prop(selected_job, 'shareLink', '');
      if (selected_share_link) {
        sessionStorage.setItem('public_job_share_link', selected_share_link);
      }

      await this.load_advert_data_for_modal(selected_job.id, selected_job.advertId);
    },

    async open_shared_advert_from_query() {
      const public_token = String(this.$route?.query?.ref || "").trim();
      const entity_type_id = Number(this.$route?.query?.entity_type_id || 0);
      const advert_id = Number(this.$route?.query?.advert_id || 0);

      if (!public_token && (!entity_type_id || !advert_id)) {
        return;
      }

      const selected_job = (this.jobs || []).find((job) => {
        if (public_token) {
          return String(job?.publicToken || "") === public_token;
        }
        return Number(job?.id) === entity_type_id && Number(job?.advertId) === advert_id;
      });

      if (!selected_job) {
        this.show_error("The shared advert is not available.");
        return;
      }

      await this.open_job_details(selected_job);
      this.$nextTick(() => {
        const modal_element = document.getElementById("job-details-modal");
        if (modal_element && window.bootstrap?.Modal) {
          const modal = window.bootstrap.Modal.getInstance(modal_element) || new window.bootstrap.Modal(modal_element);
          modal.show();
        }
      });
    },

    async load_advert_data_for_modal(entity_type_id, advert_id = null) {
      if (!entity_type_id) return;
      this.loading_profile = true;
      this.job_profile = {
        title: this.job.jobTitle || this.job.title || 'Untitled Job Advert',
        description: '',
        sections: [],
        advert_details: '',
        advert_sections: [],
        advert_order: [],
        display_blocks: [],
      };

      try {
        const response = await axios.get(`${PUBLIC_JOB_ADVERT_URL}?entity_type_id=${entity_type_id}`);

        if (response.data?.status === 'success' && response.data?.data?.length > 0) {
          const adverts = Array.isArray(response.data.data) ? response.data.data : [];
          const advert = adverts
            .slice()
            .sort((left, right) => {
              const left_time = new Date(left?.updated_at || left?.date_modified || left?.date_created || 0).getTime();
              const right_time = new Date(right?.updated_at || right?.date_modified || right?.date_created || 0).getTime();

              if (left_time !== right_time) {
                return right_time - left_time;
              }

              return (Number(right?.id) || 0) - (Number(left?.id) || 0);
            })
            .find((row, index, list) => {
              if (!advert_id) {
                return index === 0;
              }
              return Number(row?.id) === Number(advert_id) || (index === 0 && !list.some(item => Number(item?.id) === Number(advert_id)));
            });

          if (!advert) {
            return;
          }

          const split = this.split_advert_sections_and_order(advert.sections || []);
          this.job_profile.advert_details = advert.details || '';
          this.job_profile.advert_sections = this.normalize_advert_sections(split.content_sections);
          this.job_profile.advert_order = split.order_items;
          this.refresh_job_profile_display_blocks();
        } else {
          this.job_profile.advert_details = '';
          this.job_profile.advert_sections = [];
          this.job_profile.advert_order = [];
          this.refresh_job_profile_display_blocks();
        }
      } catch (error) {
        // Silently fail - adverts are optional
        // Could not load advert data: error.message
      } finally {
        this.loading_profile = false;
      }
    },

    normalize_advert_sections(raw_sections) {
      if (!Array.isArray(raw_sections)) return [];
      return raw_sections.map(section => this.normalize_advert_section(section));
    },
    build_default_advert_table(section) {
      return section?.table || { headers: [{ label: 'Column 1' }], rows: [['']] };
    },
    normalize_advert_subsections(section) {
      if (!Array.isArray(section?.subsections)) return [];
      return section.subsections.map(child => this.normalize_advert_section(child));
    },

    normalize_advert_section(section) {
      return {
        title: section?.title || '',
        descriptions: Array.isArray(section?.descriptions) ? section.descriptions : [],
        table: this.build_default_advert_table(section),
        use_columns: section?.use_columns === true,
        show_on_advert: section?.show_on_advert !== false,
        subsections: this.normalize_advert_subsections(section),
        content: section?.content || '',
      };
    },

    split_advert_sections_and_order(raw_sections) {
      const list = Array.isArray(raw_sections) ? JSON.parse(JSON.stringify(raw_sections)) : [];
      const meta = list.find(item => item && item.type === '__display_order_meta__' && Array.isArray(item.items));
      return {
        content_sections: list.filter(item => !(item && item.type === '__display_order_meta__')),
        order_items: meta?.items || [],
      };
    },

    build_default_display_order(advert_details, advert_sections) {
      const order = [];
      if (advert_details && String(advert_details).trim()) order.push({ key: 'details', source: 'details' });
      (advert_sections || []).forEach((_, idx) => order.push({ key: `section:${idx}`, source: 'section', index: idx }));
      return order;
    },

    normalize_display_order(saved_order, advert_details, advert_sections) {
      const fallback = this.build_default_display_order(advert_details, advert_sections);
      const allowed = new Set(fallback.map(item => item.key));
      const normalized = [];

      if (Array.isArray(saved_order)) {
        saved_order.forEach(item => {
          if (item && allowed.has(item.key) && !normalized.some(entry => entry.key === item.key)) {
            normalized.push(item);
          }
        });
      }

      fallback.forEach(item => {
        if (!normalized.some(entry => entry.key === item.key)) {
          normalized.push(item);
        }
      });

      return normalized;
    },

    refresh_job_profile_display_blocks() {
      const advert_sections = this.job_profile.advert_sections || [];
      const advert_details = this.job_profile.advert_details || '';
      const order = this.normalize_display_order(this.job_profile.advert_order || [], advert_details, advert_sections);

      this.job_profile.display_blocks = order.flatMap(item => {
        if (item.source === 'details') {
          return [{
            key: item.key,
            kind: 'details',
            title: 'Additional Information',
            data: advert_details,
            depth: 0,
          }];
        }

        return [{
          key: item.key,
          kind: 'section',
          title: advert_sections[item.index]?.title || `Section ${item.index + 1}`,
          data: advert_sections[item.index] || null,
          depth: 0,
        }];
      }).filter(block => !!block.data);
    },
    extract_plain_text_content(value) {
      const markup = String(value || '');
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      return (parsed.body?.textContent || '').replace(/\r\n/g, '\n').trim();
    },
    build_plain_text_lines(value) {
      return this.extract_plain_text_content(value)
        .split('\n')
        .map(line => line.trim())
        .filter(Boolean);
    },
    get_plain_text_list_tag(list_items) {
      const has_numbered_items = list_items.some(item => item.type === 'number');
      const has_bullet_items = list_items.some(item => item.type === 'bullet');
      return has_numbered_items && !has_bullet_items ? 'ol' : 'ul';
    },

    parse_plain_text_list(content) {
      if (!content) return null;
      const lines = this.build_plain_text_lines(content);
      if (!lines.length) return null;
      const bullet_line_regex = /^[\u2022\-*]\s+(.+)$/;
      const numbered_line_regex = /^\d+[.)]\s+(.+)$/;
      const list_items = lines.map((line) => this.parse_plain_text_list_item(line, bullet_line_regex, numbered_line_regex));
      if (list_items.some(item => item.type === 'text')) return null;

      return {
        tag: this.get_plain_text_list_tag(list_items),
        items: list_items.map(item => item.text),
      };
    },
    parse_plain_text_list_item(line, bullet_line_regex, numbered_line_regex) {
      const bullet_match = line.match(bullet_line_regex);
      if (bullet_match) return { type: 'bullet', text: bullet_match[1].trim() };
      const numbered_match = line.match(numbered_line_regex);
      if (numbered_match) return { type: 'number', text: numbered_match[1].trim() };
      return { type: 'text', text: line };
    },
    coerce_text_value(value) {
      if (value === null || typeof value === 'undefined') return '';
      return typeof value === 'string' ? value : `${value}`;
    },

    is_competencies_block(block) {
      const title = this.coerce_text_value(block?.title).toLowerCase();
      return title.includes('competenc');
    },

    parse_competency_groups(content) {
      const plain_text = this.extract_plain_text_content(content);
      if (!plain_text) return [];

      const label_regex = /(Knowledge|Skills|Personal Attributes|Abilities|Attitude|Minimum Qualification|Minimum Experience)\s*:/gi;
      const matches = [...plain_text.matchAll(label_regex)];

      if (!matches.length) {
        return [];
      }

      return matches.map((match, index) => {
        const label = match[1];
        const start = match.index + match[0].length;
        const end = index + 1 < matches.length ? matches[index + 1].index : plain_text.length;
        const raw_value = plain_text.slice(start, end).trim();
        const items = raw_value
          .split(/\s*[\u2022;]\s*|\n+/)
          .map(item => item.trim())
          .filter(Boolean);

        return {
          label,
          items,
          value: items.join(' • ') || raw_value,
        };
      }).filter(group => group.value);
    },

    render_block_html(_block, content) {
      return this.extract_plain_text_content(content);
    },

    section_badge_label(title) {
      const value = normalizeSectionTitleValue(title);
      const match = getSectionBadgeMatch(title);
      return match ? match[1].toUpperCase() : (value.charAt(0).toUpperCase() || 'A');
    },

    section_display_title(title) {
      const value = normalizeSectionTitleValue(title);
      return value.replace(/^[A-Z]\.\s*/i, '') || value;
    },

    strip_html_tags(text) {
      if (!text) return '';
      return String(text).replace(/<[^>]+>/g, '').trim();
    },

    has_table_content(section) {
      if (!section.table || !Array.isArray(section.table.rows)) return false;
      for (const row of section.table.rows) {
        if (!Array.isArray(row)) continue;
        for (const cell of row) {
          const cleaned = this.strip_html_tags(cell || '');
          if (cleaned && cleaned.trim().length > 0) return true;
        }
      }
      return false;
    },

    applyForJob() {
      if (!this.job?.id) {
        this.show_error('Please select a job first.');
        return;
      }

      if (this.job.status === 'Closed') {
        this.show_error('This advert is closed and cannot accept new applications.');
        return;
      }

      if (!this.job.shareLink) {
        this.show_error('Onboarding link is not available for this job yet.');
        return;
      }

      // Store selected job info so the sign-up page can pre-select it
      sessionStorage.setItem('apply_job_id', String(this.job.id));
      sessionStorage.setItem('apply_job_title', this.job.jobTitle || this.job.title || '');
      sessionStorage.setItem('apply_advert_id', this.job.advertId ? String(this.job.advertId) : '');
      localStorage.setItem('apply_job_id', String(this.job.id));
      localStorage.setItem('apply_job_title', this.job.jobTitle || this.job.title || '');
      localStorage.setItem('apply_advert_id', this.job.advertId ? String(this.job.advertId) : '');
      localStorage.setItem('apply_job_reference_number', this.job.referenceNumber || '');

      window.location.assign(this.job.shareLink);
    },
  },
};


